export const isEnterOrSpaceKey = (event: KeyboardEvent): boolean => {
  if (!event) return false;
  return event.key === 'Enter' || event.key === ' ';
};
